module.exports = __webpack_public_path__ + "img/40_38_035_520.da202ef6.jpg";